import { number, objectOf, shape, string } from 'prop-types';

import { basicProductShape } from '../../prop-types';

export const WRITABLE_BUDGET_FIELDS = [
  'netClientBudgetExternal',
  'wkzBudget',
  'freeService',
  'coInvest',
];

export const BUDGET_FIELDS = {
  NET_CLIENT_BUDGET_EXTERNAL: 'netClientBudgetExternal',
  WKZ_BUDGET: 'wkzBudget',
  FREE_SERVICE: 'freeService',
  CO_INVEST: 'coInvest',
};

export const BUDGET_FIELDS_VALUES = Object.values(BUDGET_FIELDS);

export const BUDGET_FIELDS_LABELS = {
  budget: 'Budget',
  netClientBudgetExternal: 'Net Client Budget External',
  wkzBudget: 'Net Client Budget WKZ',
  freeService: 'Free Service',
  coInvest: 'Co Invest',
};

const budgetFieldsShape = shape({
  netClientBudgetExternal: number.isRequired,
  wkzBudget: number.isRequired,
  coInvest: number.isRequired,
  freeService: number.isRequired,
});

export const productAggregatesMapShape = objectOf(
  shape({
    label: string.isRequired,
    product: basicProductShape.isRequired,
    adjustedFee: number.isRequired,
    oldValues: budgetFieldsShape.isRequired,
    newValues: budgetFieldsShape.isRequired,
  }).isRequired,
);
